import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  toolbar: {
    backgroundColor: "#FAF7F7",
    flexWrap: "wrap",
    padding: "10px 0px",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  grow: {
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {},
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  center: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginLeft: 0,
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
    },
  },
  filterSearchWrapper: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      marginTop: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: "10px",
      marginBottom: "10px",
    },
  },
  searchBox: {
    padding: "0 5px",
    backgroundColor: "#FFF",
    borderRadius: "30px",
    display: "flex",
    alignItems: "center",
    minWidth: "80px",
  },
  durationButton: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: "#fff",
    height: "40px",
    textTransform: "none",
    marginLeft: "10px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "5px",
      width: "50px",
    },
  },
  durationButtonOutlined: {
    backgroundColor: "#FAF7F7",
    color: theme.palette.primary.main,
    height: "40px",
    textTransform: "none",
    marginLeft: "10px",
    border: `1px solid ${theme.palette.primary.main}`,
    [theme.breakpoints.down("xs")]: {
      marginLeft: "5px",
      width: "50px",
    },
  },
  searchAndCopyWrapper: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      justifyContent: "center",
    },
  },
  autocomplete: {
    width: "250px",
  },
  // companyAutocomplete: {
  //   borderRadius: "30px",
  //   border: "none",
  //   backgroundColor: "#fff",
  // },
}))

export default styles
